"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const pagination_utils_1 = require("./utils/pagination-utils");
const Pagination = ({ PaginationUnit, PaginationWrapper }) => function (props) {
    const { n, nPerPage, idx, onClick } = props;
    if (n === 0) {
        return null;
    }
    const { nPage } = pagination_utils_1.getPagination(n, nPerPage);
    const units = pagination_utils_1.getPageTiles(idx, nPage).map((i) => {
        if (i < 0) {
            return (react_1.default.createElement(PaginationUnit, { key: i, isDisabled: true }, "..."));
        }
        return (react_1.default.createElement(PaginationUnit, { key: i, isActive: i === idx, onClick: () => onClick(i) }, i));
    });
    return (react_1.default.createElement(PaginationWrapper, null,
        react_1.default.createElement(PaginationUnit, { isDisabled: idx === 1, onClick: () => onClick(idx - 1) }, "\u00AB"),
        units,
        react_1.default.createElement(PaginationUnit, { isDisabled: idx === nPage, onClick: () => onClick(idx + 1) }, "\u00BB")));
};
exports.default = Pagination;
